import { render, staticRenderFns } from "./dispatch-push-panel.vue?vue&type=template&id=e4b4df74&scoped=true&"
import script from "./dispatch-push-panel.vue?vue&type=script&lang=js&"
export * from "./dispatch-push-panel.vue?vue&type=script&lang=js&"
import style0 from "./dispatch-push-panel.vue?vue&type=style&index=0&id=e4b4df74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b4df74",
  null
  
)

export default component.exports